export default {
  execute(input) {
    var Parser = require('expr-eval').Parser;
    var parser = new Parser();
    
    // verify if input has content
    for(var prop in input) {
      if(prop!=='interactionCoefficients' && input[prop].length==0) {
        var res = {};
        res.err = true;
        res.msg = prop + ' values missing';
        return res;
      }
    }
    // **************************************************************
    // ******************** variable declaration ********************
    // input data
    var criteria = input.criteria
    var actions = input.actions
    var performanceTable = input.performanceTable
    var functions = input.functions; 
    var reference_actions = input.referenceActions;
    var weights = input.weights;
    var likenessThresholds = input.likenessThresholds;
    var interaction_effects = input.interactionCoefficients;
    
    // criteria pairs of mutual interaction effects
    var mutualSet = [], antagonisticSet = [];

    // assigned actions and corresponding categories
    var assignedActions = {};

    // similarity array
    var similarityValues = [];

    // all the values of delta max
    var deltaMaxValues = {};
    var deltaValues = {};
    
    // values of per-criterion similarity-dissimilarity functions
    var functionsValues = {};
    
    // similiarity and dissimilarity values
    var sValues = [], dPlusValues = [], dMinusValues = [];

    // **************************************************************
    // ******************** main algorithm flow *********************
    
    for(var weight of weights)
      assignedActions[weight['Category']] = [];
    assignedActions['Non-assigned'] = [];

    // construct the delta max object containing all the actions and categories
    for(var action of actions) {
      deltaMaxValues[action['Name']] = {};
      deltaValues[action['Name']] = {};
    }
    
    // transform the functions' conditions to string
    conditionsToString();

    // invert the values of criteria to minimize
    minimizeCriteria();

    // calculate the sets of the interaction effects
    interactionEffectsSets();

    if(!nonNegativityCondition())
      return false;
    
    var similarityValues = applyCriterionFunction();
    
    assignActions();
      
    transformOutput();

    console.log('deltaMaxValues', deltaMaxValues)
    console.log('deltaValues', deltaValues)
    console.log('sValues', sValues)
    console.log('dMinusValues', dMinusValues)
    console.log('dPlusValues', dPlusValues)
    console.log('functionsValues', functionsValues)
    return assignedActions;
    //return [assignedActions, deltaMaxValues, deltaValues, sValues, dMinusValues, dPlusValues, functionsValues];

    // **************************************************************
    // ******************** auxiliary functions *********************

    function conditionsToString() {
      for(var func of functions) {
        if(!isNaN(func['Condition']))
          func['Condition'] = func['Condition'].toString(); 
        if(!isNaN(func['Value'])) // TODO: added this part, function['Value'] was sometimes an integer, error with parser
          func['Value'] = func['Value'].toString();
      }
    }

    function minimizeCriteria() {
      for(var crit of criteria) {
        if(crit['Direction'] == 'Minimization') {
          for(var act of performanceTable)
            act[crit['Name']] = -act[crit['Name']];
          for(var ref of reference_actions)
            ref[crit['Name']] = -ref[crit['Name']];
        }
      }
    }

    // set M (mutual effect) and set O (antagonistic)
    function interactionEffectsSets() {
      for(var effect of interaction_effects) {
        if(effect['Type'] == 'Mutual-Strengthening' || effect['Type'] == 'Mutual-Weakening')
          mutualSet.push(effect);
        else
          antagonisticSet.push(effect);
      }
    }

    // guarantee that the weights of the criteria never become negative 
    // after considering the interaction effects
    function nonNegativityCondition() {
      for(var crit of criteria) {
        for(var cat of weights) {
          var kij = cat[crit['Name']];
          var kjl = 0;
          for(var pair of mutualSet)
            if(cat['Category'] == pair['Category'])
              if(pair['Criterion1'] == crit['Name'] || pair['Criterion2'] == crit['Name'])
                if(pair['Value'] < 0)
                  kjl += Math.abs(pair['Value']);
          var kjp = 0;
          for(var pair2 of antagonisticSet)
            if(cat['Category'] == pair2['Category'])
              if(pair2['Criterion1'] == crit['Name'])
                kjp += Math.abs(pair2['Value']);
          if((kij - kjl - kjp) < 0)
            return false;
        }
      }
      return true;
    }

    function applyCriterionFunction() {
      for(var criterion of criteria) {
        for(var action of performanceTable) {
          for(var reference_action of reference_actions) {
            // arguments used in the functions
            var arg1 = action[criterion['Name']];
            var arg2 = reference_action[criterion['Name']];
            for(var branch of functions) {
              if(branch['Criterion'] == criterion['Name']) {
                var condition = branch['Condition'];
                // check the occurences of '=' and replace it by '=='
                condition = condition.replace(/=/g, '==');
                // check the occurences of ',' and replace it by '.'
                condition = condition.replace(/,/g, '.');
                // check the occurrences of '<==', '>==' and '!==' and replace them by '<=', '>=' and '!=' respectively
                condition = condition.replace(/<==/g, '<=');
                condition = condition.replace(/>==/g, '>=');
                condition = condition.replace(/!==/g, '!=');
                var cond = parser.parse(condition);
                var result = cond.evaluate({x: Number(arg1), y: Number(arg2)});
                if(result) {
                  var func = branch['Value'];
                  // check the occurences of ',' and replace it by '.'
                  func = func.replace(/,/g, '.');
                  var func_branch = parser.parse(func);
                  result = func_branch.evaluate({x: Number(arg1), y: Number(arg2)});
                  var result_obj = {};
                  result_obj['Criterion'] = criterion['Name'];
                  result_obj.action = action['Name'];
                  result_obj.reference_action = reference_action['Name'];
                  result_obj.result = result;
                  similarityValues.push(result_obj);
                  break;
                }
              }
            }
          }
        }
      }
      for(var item of antagonisticSet) {
        for(var criterion of criteria) {
          if(criterion['Name'] == item['Criterion2']) {
            for(var action of performanceTable) {
              for(reference_action of reference_actions) {
                // arguments used in the functions
                var arg1 = action[criterion['Name']];
                var arg2 = reference_action[criterion['Name']];
                for(var branch of functions) { // TODO: it may be a mistake. might me missing respective criterion function validation
                  var condition = branch['Condition'];
                  if((condition.indexOf('=') != -1) && (condition.indexOf('<=') == -1) && (condition.indexOf('>=') == -1) && (condition.indexOf('!=') == -1)) {
                    var a = branch['Condition'];
                    var b = '=';
                    var position = branch['Condition'].indexOf('=');
                    condition = [a.slice(0, position), b, a.slice(position)].join('');
                  }
                  var cond = parser.parse(condition);
                  var result = cond.evaluate({x: Number(arg2), y: Number(arg1)});
                  if(result) {
                    var func_branch = parser.parse(branch['Value']);
                    result = func_branch.evaluate({x: Number(arg2), y: Number(arg1)});
                    var result_obj = {};
                    result_obj['Criterion'] = criterion['Name'];
                    result_obj.reference_action = action['Name'];
                    result_obj.action = reference_action['Name'];
                    result_obj.result = result;
                    similarityValues.push(result_obj);
                    break;
                  }
                }
              }
            }
          }
        }
      }
      return similarityValues;
    }

    // when fj(gj(a)) is non-negative, similarity coefficient is sj(a,b)
    function sj(criterion, action, reference_action) {
      var result;
      for(var item of similarityValues) {
        if(item['Criterion'] == criterion && item['action'] == action && item['reference_action'] == reference_action) {
          result = item['result'];
          break;
        }
      }
      if(result < 0 || result == undefined)
        result = 0;
      return result;
    }

    // when fj(gj(a)) is non-negative, similarity coefficient is dj(a,b)
    function dj(criterion, action, reference_action) {
      var result;
      for(var item of similarityValues) {
        if(item['Criterion'] == criterion && item['action'] == action && item['reference_action'] == reference_action) {
          result = item['result'];
          break;
        }
      }
      if(result > 0 || result == undefined)
        result = 0;
      return result;
    }

    // z : [0,1]*[0,1]->[0,1] is a real-valued function
    function z(x, y) {
      return x * y;
    }

    function k(action, reference_action, category) {
      var result = 0; // FIXME: not used, should not be necessary
      var kj = 0;
      for(var crit of criteria) {
        kj += category[crit['Name']];
      }
      var kij = 0;
      for(var pair of mutualSet) {
        if(category['Category'] == pair['Category']) {
          var f_value1, f_value2;
          for(var item of similarityValues) {
            if(item['Criterion'] == pair['Criterion1'] && item['action'] == action['Name'] && item['reference_action'] == reference_action['Name']) {
              f_value1 = item['result'];
            }
            else if(item['Criterion'] == pair['Criterion2'] && item['action'] == action['Name'] && item['reference_action'] == reference_action['Name']){
              f_value2 = item['result'];
            }
          }
          if(f_value1 > 0 && f_value2 > 0) {
            var s1 = sj(pair['Criterion1'], action['Name'], reference_action['Name']);
            var s2 = sj(pair['Criterion2'], action['Name'], reference_action['Name']);
            kij += z(s1, s2) * pair['Value'];
          }
        }
      }
      var kih = 0;
      for(var pair2 of antagonisticSet) {
        if(category['Category'] == pair2['Category']) {
          var f_value3, f_value4;
          for(var item of similarityValues) {
            if(item['Criterion'] == pair2['Criterion1'] && item['action'] == action['Name'] && item['reference_action'] == reference_action['Name']) {
              f_value3 = item['result'];
            }
            else if(item['Criterion'] == pair2['Criterion2'] && item['action'] == action['Name'] && item['reference_action'] == reference_action['Name']){
              f_value4 = item['result'];
            }
          }
          if(f_value3 > 0 && f_value4 < 0) {
            var s3 = sj(pair2['Criterion1'], action['Name'], reference_action['Name']);
            var s4 = dj(pair2['Criterion2'], action['Name'], reference_action['Name']);
  
            kih += z(s3, s4) * pair2['Value'];
          }
        }
      }
      return kj + kij - kih;
    }

    // a non-additive similarity function
    function s(action, reference_action, category) {
      var result = 0;
      for(var crit of criteria)
        result += category[crit['Name']] * sj(crit['Name'], action['Name'], reference_action['Name']);

      for(var pair of mutualSet) {
        if(category['Category'] == pair['Category']) {
          var f_value1, f_value2;
          for(var item of similarityValues) {
            if(item['Criterion'] == pair['Criterion1'] && item.action == action['Name'] && item.reference_action == reference_action['Name'])
              f_value1 = item.result;
            else if(item['Criterion'] == pair['Criterion2'] && item.action == action['Name'] && item.reference_action == reference_action['Name'])
              f_value2 = item.result;
          }
          if(f_value1 > 0  && f_value2 > 0) {
            var s1 = sj(pair['Criterion1'], action['Name'], reference_action['Name']);
            var s2 = sj(pair['Criterion2'], action['Name'], reference_action['Name']);
            result += z(s1, s2) * pair['Value'];
          }
        }
      }
      for(var pair2 of antagonisticSet) {
        if(category['Category'] == pair2['Category']) {
          var f_value3, f_value4;
          for(var item of similarityValues) {
            if(item['Criterion'] == pair2['Criterion1'] && item['action'] == action['Name'] && item['reference_action'] == reference_action['Name'])
              f_value3 = item['result'];
            else if(item['Criterion'] == pair2['Criterion2'] && item['action'] == action['Name'] && item['reference_action'] == reference_action['Name'])
              f_value4 = item['result'];
          }
          if(f_value3 > 0 && f_value4 < 0) {
            var s3 = sj(pair2['Criterion1'], action['Name'], reference_action['Name']);
            var s4 = dj(pair2['Criterion2'], action['Name'], reference_action['Name']);
            result -= z(s3, s4) * pair2['Value'];
          }
        }
      }
      var res2 = result/k(action, reference_action, category);
      return res2;
    }

    //a non-linear dissimilarity function
    function dPlus(action, reference_action) {
      var result = 1;
      for(var crit of criteria)
        if(action[crit['Name']] > reference_action[crit['Name']])
          result *= (1 + dj(crit['Name'], action['Name'], reference_action['Name']));
      return result - 1;
    }

    function dMinus(action, reference_action) {
      var result = 1;
      for(var crit of criteria)
        if(reference_action[crit['Name']] > action[crit['Name']])
          result *= (1 + dj(crit['Name'], action['Name'], reference_action['Name']));
      return result - 1;
    }

    // a multiplicative comprehensive similarity function
    function delta(action, reference_action, category) {
      var s_result = s(action, reference_action, category);
      var dPlus_result = 1 + dPlus(action, reference_action);
      var dMinus_result = 1 + dMinus(action, reference_action);
      var result = s_result * dPlus_result * dMinus_result;
      // create and store an object with the action, reference action and value of the delta function
      deltaValues[action['Name']][reference_action['Name']] = result;
      sValues.push({
        action: action['Name'],
        reference_action: reference_action['Name'],
        Value: s_result
      });
      dMinusValues.push({
        action: action['Name'],
        reference_action: reference_action['Name'],
        Value: dMinus_result - 1
      });
      dPlusValues.push({
        action: action['Name'],
        reference_action: reference_action['Name'],
        Value: dPlus_result - 1
      });
      return result;
    }

    function deltaMax(action, category) {
      var result = 0;
      for(var ref of reference_actions) {
        if(ref['Category'] == category['Category']) {
          var res = delta(action, ref, category);
          if(res > result)
            result = res;
        }
      }
      return result;
    }

    // similarity assignment procedure
    function assignActions() {
      for(var action of performanceTable) {
        // set K - categories to assign action to
        var k_set = [];
        // compare action with set B of category
        for(var cat of likenessThresholds) {
          var weight = weights.find(obj => {return obj['Category'] === cat['Category']})
          var result = deltaMax(action, weight);
          if(result >= cat['Value'])
            k_set.push(cat['Category']);
          // create and store an object with the action, category and value of the delta max function
          deltaMaxValues[action['Name']][cat['Category']] = result;
        }
        // if the action was not assigned to any category, assign it to the "Non-assigned" category
        if(k_set.length == 0)
          assignedActions['Non-assigned'].push(action['Name']);
        else
          for(var cat of k_set)
            assignedActions[cat].push(action['Name']);
      }
    }

    // transform output to more convenient format
    function transformOutput() {
      // assigned actions
      var assigned_actions = [];
      for(var action of performanceTable) {
        var action_obj = {'Action' : action['Name']};
        for(var cat of weights) {
          if(assignedActions[cat['Category']].includes(action['Name']))
            action_obj[cat['Category']] = true;
          else
            action_obj[cat['Category']] = false;
        }
        if(assignedActions['Non-assigned'].includes(action['Name']))
          action_obj['Non-assigned'] = true;
        else
          action_obj['Non-assigned'] = false;
        assigned_actions.push(action_obj);
      }
      assignedActions = assigned_actions;
      // delta maximum values
      var delta_max_values = [];
      for(var action of performanceTable) {
        var delta_max_obj = {'Action' : action['Name']};
        for(var cat of weights)
          delta_max_obj[cat['Category']] = deltaMaxValues[action['Name']][cat['Category']];
        delta_max_values.push(delta_max_obj);
      }
      deltaMaxValues = delta_max_values;
      // delta values
      var delta_values = [];
      for(var action of performanceTable) {
        var delta_obj = {'Action' : action['Name']};
        for(var ref of reference_actions)
          delta_obj[ref['Name']] = deltaValues[action['Name']][ref['Name']];
        delta_values.push(delta_obj);
      }
      deltaValues = delta_values;
      // functions values
      var functions_values = [];
      for(var crit of criteria) {
        var new_crit_obj = {
          Criterion: crit['Name'],
          results: []
        };
        for(var action of performanceTable) {
          var new_action_obj = {
            action: action['Name']
          };
          for(var value of similarityValues)
            if(value['Criterion'] == new_crit_obj['Criterion'] && value.action == action['Name'])
              new_action_obj[value.reference_action] = value.result;
          new_crit_obj.results.push(new_action_obj);
        }
        functions_values.push(new_crit_obj);
      }
      functionsValues = functions_values;
      // similarity values
      var s_values = [];
      for(var action of performanceTable) {
        var new_action_obj = {
          action : action['Name'],
        };
        for(var value of sValues)
          if(value.action == new_action_obj.action) 
            new_action_obj[value.reference_action] = value['Value'];
        s_values.push(new_action_obj);
      }
      sValues = s_values;
      // dMinusValues
      var d_minus_values = [];
      for(var action of performanceTable) {
        var new_action_obj = {
          action : action['Name'],
        };
        for(var value of dMinusValues)
          if(value.action == new_action_obj.action)
            new_action_obj[value.reference_action] = value['Value'];
        d_minus_values.push(new_action_obj);
      }
      dMinusValues = d_minus_values;
      // dPlusValues
      var d_plus_values = [];
      for(var action of performanceTable) {
        var new_action_obj = {
          action : action['Name'],
        };
        for(var value of dPlusValues)
          if(value.action == new_action_obj.action)
            new_action_obj[value.reference_action] = value['Value'];
        d_plus_values.push(new_action_obj);
      }
      dPlusValues = d_plus_values;
    }

  }
}


// WEBPACK FOOTER //
// ./src/services/CATSDService.js